import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "src/constants";
import { BaseModel, Issue } from "src/types";

interface UseResolveIssueOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useResolveIssue = <T extends BaseModel & Issue>(
  resolveIssueFn: (id: string, resolutionDetails: string) => Promise<T | undefined>,
  options?: UseResolveIssueOptions
) => {
  const queryClient = useQueryClient();

  return useMutation<T | undefined, Error, { id: string; resolutionDetails: string }>({
    mutationFn: ({ id, resolutionDetails }) => resolveIssueFn(id, resolutionDetails),
    onSuccess: (data) => {
      if (!data) {
        return;
      }

      queryClient.invalidateQueries({ queryKey: queryKeys.receivingDiscrepancy(data.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.unknownArrival(data.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.activeAntsReceivingDiscrepancy(data.id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.activeAntsPurchaseOrder(data.id) });

      options?.onSuccess?.();
    },
    onError: (error) => options?.onError?.(error)
  });
};
